let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4M64U")).then(() => parcelRequire('fAZvw'));